import { Component, ViewChild, ViewChildren, OnInit, QueryList, ElementRef, AfterViewInit, PACKAGE_ROOT_URL, OnDestroy } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { PageEvent, MatPaginator, MatPaginatorModule } from '@angular/material/paginator';

//import { Abstract } from '../../../models/abstract/abstract.model';

import { AbstractKappas } from '../../../models/abstract/abstract-kappas.model';
import { AbstractKappasFlatten } from '../../../models/abstract/abstract-kappas-flatten.model';
import { AbstractKappasFlattenRecon } from '../../../models/abstract/abstract-kappas-flatten-recon.model';



import { AbstractSearchResult } from '../../../models/abstract/abstract-search-result.model';
import { AbstractSearchKeys } from '../../../models/abstract/abstract-search.model';
import { GenericSelectOption } from '../../../models/generic-select-option.model';
import { AbstractSearchMetadata } from '../../../models/abstract/abstract-search-metadata.model';
import { MenuFilterOption } from '../../../models/menu/menu-filter-option.model';
import { MenuActionOption } from '../../../models/menu/menu-action-option.model';
import { ActionAbstracts } from '../../../models/abstract/action-abstracts.model';
import { AutoSampleResult } from '../../../models/abstract/auto-sample-result.model';


import { AbstractService } from '../../../services/abstract.service';
import { AccountService } from "../../../services/account.service";
import { AuthService } from "../../../services/auth.service";
import { AlertService, DialogType, MessageSeverity } from '../../../services/alert.service';
import { ReportService } from '../../../services/report.service';
import { Utilities } from '../../../services/utilities';

import { merge, Observable, Subject, of as observableOf, Subscription } from 'rxjs';
import { catchError, map, startWith, switchMap, debounceTime, takeUntil } from 'rxjs/operators';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DecisionBottomSheetComponent } from '../../bottom-sheet/decision-bottom-sheet/decision-bottom-sheet.component';

import { HttpClient } from '@angular/common/http';


import { ExcelService } from '../../../services/excel.service';
import { Roles } from '../../../models/enums';
import { FullProtocol } from '../../../models/protocol/full-protocol.model';
import { ProtocolService } from '../../../services/protocol.service';
import { User } from '../../../models/user.model';
import { QcWeekDay } from '../../../models/report/qc-week-day.model';
import { isNull, isUndefined } from 'util';
import { ConfirmBottomSheetComponent } from '../../bottom-sheet/confirm-bottom-sheet/confirm-bottom-sheet.component';
import { CommonModule, formatDate } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
//import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { AllCommunityModule, ModuleRegistry, GridOptions } from 'ag-grid-community';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { rename } from 'fs/promises';

ModuleRegistry.registerModules([AllCommunityModule]);

interface MechGrpItem {
  title: string;
  rate: number;
  ingrpcount: number;
  ingrpabpros: AbstractKappas[];
  sampleN: number;
  qcselectedcount: number;
}

@Component({
  selector: 'app-manage-reconciliation-abstracts',
  templateUrl: './manage-reconciliation-abstracts.component.html',
  styleUrls: ['./manage-reconciliation-abstracts.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatSelectModule,
    MatSortModule,
    MatSnackBarModule,
    //MatTableModule,
    ReactiveFormsModule,
    AgGridAngular,
    AgGridModule
  ],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ])]
})
export class ManageReconciliationAbstractsComponent implements OnInit, AfterViewInit, OnDestroy {

  abstractCount: number = 10;
  abstractsPerPage: number = 10;
  showPaginator: boolean = true;
  recordsCount: number;

  isAdmin: boolean = false;
  isOdpSupervisor: boolean = false;
  isOdpStaff: boolean = false;
  isCoderSupervisor: boolean = false;
  isCoder: boolean = false;

  roles: string[] = [];
  isSupervisorView: boolean = false;
  isStaffView: boolean = false;
  qcViewQcList: boolean = false;
  qcViewCoderQList: boolean = false;
  qcViewFiltered: boolean = false;

  protocols: FullProtocol[] = [];
  protocolSelected: number = 0;
  protocolSelectedTitle: string = "";

  westatCoders: User[] = [];
  selectedCoders: number[] = [];
  // This is being added so that I can wait to trigger the load until the user is done selecting excluded users (closes the users dropdown)
  oldSelectedCoders: number[] = [];
  weeks: QcWeekDay[] = [];
  dates: { text: string, value: QcWeekDay }[];
  selectedWeek: QcWeekDay;
  invalidEndDate: boolean = false;
  qcAltView1DisplayText: string = "";
  qcAltView2DisplayText: string = "";
  qcFiltersDisplayText: string = "";
  qcFilterCountsDisplayText: string = "";
  qcMechGrps: MechGrpItem[] = [];
  abstractTeams: number[] = [];
  unfiltAllCount: number = 0;
  unfiltReconciliationCount: number = 0;
  unfiltCoderqCount: number = 0;
  unfiltODPAdjuCount: number = 0;
  isFiltCountAlert: boolean = false;
  currentFiltReconciliationCount: number = 0;
  currentFiltCoderqCount: number = 0;
  currentFiltODPAdjuCount: number = 0;

  loadingIndicator: boolean = false;
  filteroptions: GenericSelectOption[] = [];
  actionoptions: GenericSelectOption[] = [];
  abstractsData: AbstractSearchResult = new AbstractSearchResult();
  //abProIdsFullForQCReset: number[] = [];
  abProIdsFullQCEligPoolCurrent: number[] = [];
  //abstracts: Abstract[] = [];
  metadata: AbstractSearchMetadata;
  abstractSearchKeys: AbstractSearchKeys = new AbstractSearchKeys();
  filterOptionSelected: string = "";
  searchTerm: string = "";
  private subject: Subject<string> = new Subject();
  actionOptionSelected: string = "";
  resultsLength: number = 0;
  isLoadingResults: boolean = true;
  isRateLimitReached: boolean = false;
  selectedRowIndex: number = -1;
  filterByProtocol: boolean = false;

  highPriDisagreementSamplePercent: number = 0;
  lowPriDisagreementSamplePercent: number = 0;
  fullAgreementSamplePercent: number = 0;
  highPriDisagreeAutoCount?: number;
  lowPriDisagreeAutoCount?: number;
  fullAgreeAutoCount?: number;
  totalAutoSampleCount?: number;
  eligibleAbstractsWithMlDataCount?: number;
  actualAbstractsInReconWithMlDataCount?: number;
  manualActionSnackBarText: string = "";
  activeActionName: string = "";
  currentSampleNumber: number = 0;
  currentSampleRatio: number = 0;
  autoSelectPercent: number = 0;

  autoSampleResult: AutoSampleResult = new AutoSampleResult();
  isAutoSampling: boolean = false;
  autoSampleHighPriDisagreeResultCount: number = 0;
  autoSampleLowPriDisagreeResultCount: number = 0;
  autoSampleFullAgreeResultCount: number = 0;

  activeProjectTitle: string;

  private destroy$: Subject<void> = new Subject();


  colDefsQcEligibleFilter: ColDef[] = [
    {
      headerName: "In Recon. List", filter: 'agTextColumnFilter', field: "inReviewList", autoHeight: true, wrapText: true, minWidth: 115, maxWidth: 115, cellRenderer: params => {
        if (params.value === true) {
          return 'Yes';
        } else if (params.value === false) {
          return 'No';
        }
        return ''; // Handle null or undefined values if needed
      }
    },
    {
      headerName: "QC Coder Question", filter: 'agTextColumnFilter', field: "reviewRecommended", autoHeight: true, wrapText: true, minWidth: 114, maxWidth: 130, cellRenderer: params => {
        if (params.value === true) {
          return 'Yes';
        } else if (params.value === false) {
          return 'No';
        }
        return ''; // Handle null or undefined values if needed
      }
    },    
    { headerName: "QC Consensus / ML Agreement", filter: 'agTextColumnFilter', field: "submissionAgreePriorityTitle", autoHeight: true, wrapText: true, minWidth: 148 },
    {
      headerName: "ODP Adjudication", filter: 'agTextColumnFilter', field: "adjudicationRecommended", autoHeight: true, wrapText: true, minWidth: 138, cellRenderer: params => {
        if (params.value === true) {
          return 'Yes';
        } else if (params.value === false) {
          return 'No';
        }
        return ''; // Handle null or undefined values if needed
      }
    },
    // { headerName: "Type", field: "type", autoHeight: true, wrapText: true, minWidth: 86 },
    { headerName: "Mech", filter: 'agTextColumnFilter', field: "mechanism", autoHeight: true, wrapText: true, minWidth: 92, maxWidth: 96 },
    /*{ headerName: "QC Sample Rate", field: "samplingRate", autoHeight: true, wrapText: true, minWidth: 140 },
    { headerName: "SubCategory Group", field: "subcategoryGroupTitle", autoHeight: true, wrapText: true, minWidth: 140 },*/
    { headerName: "Application ID", field: "application", filter: 'agTextColumnFilter', autoHeight: true, wrapText: true, minWidth: 145 },
    { headerName: "Project Number", filter: 'agTextColumnFilter', field: "projectNumber", autoHeight: true, wrapText: true, minWidth: 110 },
    { headerName: "FY", field: "fy", filter: 'agTextColumnFilter', autoHeight: true, wrapText: true, minWidth: 88, maxWidth: 88 },
    {
      headerName: "QC Coded Date", field: "statusDate", autoHeight: true, wrapText: true, initialWidth: 114, minWidth: 114, filter: 'agDateColumnFilter', valueFormatter: params => {
        if (!params.value) return '';
        const date = new Date(params.value);
        return date.toLocaleString('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        }).replace(/,/g, "");
      }
    },
    // { headerName: "PI Name", field: "piProjectLeader", filter: 'agTextColumnFilter', autoHeight: true, wrapText: true, minWidth: 110 },
    {
      headerName: "Title", field: "projectTitle", filter: 'agTextColumnFilter', autoHeight: true, wrapText: true, minWidth: 225, cellRenderer: params => {
        const rowData = params.data;
        return `<u style="color:blue">
            ${params.value}
            (${rowData.abstractStatusTitle})
          </u>`;
      }, onCellClicked: (event) => {
        const data = event.node.data;
        setTimeout(() => {
          this.checkAbstractForCodingBeforeNavigate(data.abstractId, data.projectTitle);          
          this.loadingIndicator = false;
          this.isLoadingResults = false;
        }, 0);
      }
    },
    { headerName: "QC Coders", field: "coderTeamUsers", filter: 'agTextColumnFilter', autoHeight: true, wrapText: true, minWidth: 110 }
  ];

  defaultColDef: ColDef = {
    wrapHeaderText: true,
    autoHeaderHeight: true,
  };
  gridOptions: GridOptions = {
    autoSizeStrategy: {
      type: 'fitGridWidth'
    },
    suppressColumnVirtualisation: true,
    enableCellTextSelection: true,
    ensureDomOrder: true,
    rowSelection: {
      mode: 'multiRow',
      checkboxes: true,
      headerCheckbox: true,
      enableClickSelection: false
    },
    onRowSelected: (event) => {
      if (event.node.isSelected()) {
        this.selection.select(event.node.data)
      } else {
        this.selection.deselect(event.node.data)
      }
    },
    /*pagination: true,
    paginationPageSizeSelector: [10, 25, 50, 100, 250, 500],
    paginationPageSize: 10,
    onPaginationChanged: (event) => {
      const api = event.api;
      const currentPage = api.paginationGetCurrentPage();
      const pageSize = api.paginationGetPageSize();
      if (this.abstractSearchKeys.pageNumber != currentPage || this.abstractSearchKeys.pageSize != pageSize) {
        this.abstractSearchKeys.pageNumber = currentPage;
        this.abstractSearchKeys.pageSize = pageSize;
        this.loadAbstractData(this.protocolSelected);
      }
    },*/
    //rowModelType: "infinite",
    domLayout: 'autoHeight',
    //onVirtualColumnsChanged: (event) => {
    //  var gridRules = event.api.autoSizeAllColumns();
    //},
    suppressMovableColumns: true
  };

  // Tracks subscriptions in the loadAbstractData method and
  // unsubscribes to old calls if the last call is incomplete
  loadAbstractDataSubTrack: Subscription | null = null;

  dataSource: AbstractKappas[] = []; //this.abstractsData.abstracts; /*new MatTableDataSource<Abstract>();*/
  rowData = [];
  colDefs: ColDef[] = this.colDefsQcEligibleFilter;
  selection = new SelectionModel<AbstractKappas>(true, []);
  // MatPaginator Output
  pageEvent: PageEvent;
  pageSize = 250;

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();;
  //@ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatSelect) matSelectFilter: MatSelect;

  constructor(private abstractService: AbstractService,
    private alertService: AlertService,
    private accountService: AccountService,
    private authService: AuthService,
    private reportService: ReportService,
    public router: Router,
    private activeRoute: ActivatedRoute,
    private bottomSheet: MatBottomSheet,
    private http: HttpClient,
    private excelService: ExcelService,
    private protocolService: ProtocolService,
    private snackBar: MatSnackBar) {


  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  exportQcCoderQListAsXLSX(): void {

    var toExportJson = [];

    this.selection.selected.forEach(function (obj: AbstractKappas) {

      var flatten: AbstractKappasFlattenRecon = new AbstractKappasFlattenRecon();

      flatten.ApplicationID = obj.application;
      flatten.ProjectNumber = obj.projectNumber;
      flatten.FY = obj.fy;
      flatten.Type = obj.type;
      flatten.Mech = obj.mechanism;
      flatten.StatusDate = obj.statusDate;
      flatten.Title = obj.projectTitle;
      flatten.PIName = obj.piProjectLeader;
      flatten.Description = obj.descPart;
      flatten.PublicHealthPart = obj.publicHealthPart;
      flatten.HasNotes = obj.flags; /// obj.flags is populated in AutoMapperProfile.cs - if any note records, then "Yes"
      flatten.InQcList = obj.inReviewList.toString(); /// abstract was selected for Reconciliation List (random ODP coding)
      flatten.ReviewRequested = obj.reviewRecommended.toString(); /// coders requested ODP review (coding) of abstract
      flatten.AdjudicationRequested = obj.adjudicationRecommended.toString();
      flatten.SubmissionAgreePriorityTitle = obj.submissionAgreePriorityTitle.toString();
      //flatten.QcSampleRate = obj.samplingRate.toString() + "%";
      flatten.SubcategoryGroupTitle = obj.subcategoryGroupTitle;
      flatten.Coders = obj.coderTeamUsers;

    //for each item in noteList
      // get the Note add to noteText, username and date
      // add to flatten
      var noteText = "";
      var noteList = obj.coderNotes;
      if (noteList.length > 0) {
        noteList.forEach((note) => {
          noteText += formatDate(note.lastModifiedDate, 'yyyy-MM-dd hh:mm a', 'en-US', 'America/New_York') + " ET - " + note.applicationUser.fullName + ": " + note.notePlain + "\n";
          })
      }
      flatten.Notes = noteText;
  
      toExportJson.push(flatten);
    })

    /// [BJL 2025-09-23] Note that the columns in the Excel export, both number of columns and their order,
    /// are determined by the attributes the AbstractKappasFlattenRecon class. It doesn't matter what values you set 
    /// in "flatten" (above), or the order in which you set them - you must make sure that the columns in renameColHeaders
    /// correspond to those in AbstractKappasFlattenRecon.
    var renameColHeaders = [];
    renameColHeaders.push("Application ID");
    renameColHeaders.push("Project Number");
    renameColHeaders.push("FY");
    renameColHeaders.push("Type");
    renameColHeaders.push("Mechanism");
    renameColHeaders.push("QC Coded Date");
    renameColHeaders.push("Title");
    renameColHeaders.push("PI Project Leader");
    renameColHeaders.push("Description");
    renameColHeaders.push("Public Health Part");   
    renameColHeaders.push("In Reconciliation List");
    renameColHeaders.push("QC Coder Question");
    renameColHeaders.push("Request ODP Adjudication");
    renameColHeaders.push("Has Notes");
    renameColHeaders.push("Notes");
    renameColHeaders.push("ML Agreement");
    renameColHeaders.push("SubCategory Group");
    renameColHeaders.push("QC Coders");

    this.excelService.exportAsExcelFile(toExportJson, 'AbstractExport', renameColHeaders);
  }

  selectProtocol(protocol: FullProtocol): void {
    this.paginator.forEach(p => p.pageIndex = 0);
    this.abstractSearchKeys.pageNumber = 0;
    this.loadAbstractSearchMetaData(protocol.id);
    this.loadAbstractData(protocol.id);
  }

  public ngOnInit(): void {
    if (this.authService.isSessionExpired) {
      console.log(`ABSTRACT LIST: REDIRECT TO LOGIN`);
      this.router.navigateByUrl('/account/login');
    }
    else {
      this.activeRoute.paramMap.subscribe((paramMap) => {
        var viewParam = paramMap.get('view');
        this.isSupervisorView = viewParam == "sup";
        this.isStaffView = viewParam == "staff";

        this.abstractCount = 10;
        this.abstractsPerPage = 10;
        this.showPaginator = true;
        this.filterOptionSelected = "";
        this.selectedCoders = [];
        this.oldSelectedCoders = [];
        this.selectedWeek = null;
        this.invalidEndDate = false;
        ///[Notes:BJL_2024-05-08] Change filterByProtocol to default to true
        this.filterByProtocol = true;

        this.abstractSearchKeys = new AbstractSearchKeys();
        this.abstractSearchKeys.odpProjectWorkflowId = this.accountService.GetActiveProject().odpProjectWorkflowId;
        this.abstractSearchKeys.odpUncodedOnly = true;
        this.abstractSearchKeys.pageSize = 250;
        this.abstractSearchKeys.pageNumber = 0;
        this.abstractSearchKeys.sortColumnName = "statusDate";
        this.abstractSearchKeys.sortDirection = "asc";

        this.isSupervisorView = true;

        this.colDefs = this.colDefsQcEligibleFilter;
        this.abstractSearchKeys.excludedUsers = [];
        this.abstractSearchKeys.qcWeek = null;
        var projectCodingStartDate = "";
        this.activeProjectTitle = this.accountService.GetActiveProject().projectTitle;
        if (this.accountService.GetActiveProject() && this.accountService.GetActiveProject().codingStartDate) {
          projectCodingStartDate = this.accountService.GetActiveProject().codingStartDate;
        }
        this.reportService.getQcDatesWithStart(projectCodingStartDate).subscribe({ next: weeksResult => {
          this.weeks = weeksResult;
          this.dates = this.weeks.map(w => ({ text: `${w.datesContractorCoded}`, week: `${w.qcWeek}`, value: w }));

          /*var todayDt = new Date();
          var defaultDtSet = 0;
          this.weeks.forEach((wk) => {
            if (defaultDtSet == 0) {
              var wkEndDt = new Date(wk.datesContractorCoded.substring(wk.datesContractorCoded.indexOf("-") + 1));
              var tdycmpr = todayDt.valueOf();
              var endcmpr = wkEndDt.setDate(wkEndDt.getDate() + 1);
              var bgncmpr = wkEndDt.setDate(wkEndDt.getDate() - 7);
              if ((tdycmpr < endcmpr) && (tdycmpr > bgncmpr)) {
                this.selectedWeek = wk;
                this.abstractSearchKeys.qcWeek = this.selectedWeek.qcWeek;
                defaultDtSet = 1;
              }
            }
          });*/
        }, error: error => {
          this.alertService.showStickyMessage(
            'QC Weeks Load Error',
            `Unable to retrieve protocols from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
            MessageSeverity.error, error);
          }});

        /// Get coders to get users for "exclude users" ddl - ONLY include users who are also in ReconciliationCoder role
        this.accountService.getFullWestatCoders().subscribe(westatCodersResult => {

          westatCodersResult.forEach((user) => {
            if (user.roles.toString().toLowerCase().includes("reconciliationcoder") && user.isEnabled) {
              this.westatCoders.push(user);
            }
          });

        },
          error => {
            this.alertService.showStickyMessage(
              'Westat Coder List Load Error',
              `Unable to retrieve coders result from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
              MessageSeverity.error, error);
          });

        this.abstractSearchKeys.excludeAbstractsRecommendedForReview = false;
        this.abstractSearchKeys.excludeAbstractsInQcList = false;

        this.isAdmin = this.accountService.IsAdminRole();
        this.isOdpSupervisor = this.accountService.IsOdpSupervisorRole();
        this.isOdpStaff = this.accountService.IsOdpStaffRole();
        this.isCoderSupervisor = this.accountService.IsCoderSupervisorRole();
        this.isCoder = this.accountService.IsCoderRole();

        if (this.metadata && this.metadata.menuFilterOptions) {
          this.processMetadata();
          this.loadAbstractData(this.protocolSelected);
          //this.buildQcSelectPoolMechs();
        }
      });

      if (!this.isAdmin
        && !this.isOdpSupervisor
        && !this.isOdpStaff
        && !this.isCoderSupervisor
        && !this.isCoder)
        this.router.navigateByUrl('/home/actions');
    }
  }

  public ngAfterViewInit() {
    this.initializeAbstractSearchMetadata();

    this.subject.pipe(debounceTime(1000)).subscribe(() => {
      this.abstractSearchKeys.pageNumber = 0;
      this.paginator.forEach(p => p.pageIndex = 0);
      this.loadAbstractData(this.protocolSelected);
    });

    this.paginator.forEach(p => p.page.subscribe(() => {
      this.abstractSearchKeys.pageNumber = p.pageIndex;
      this.abstractSearchKeys.pageSize = p.pageSize;
      this.loadAbstractData(this.protocolSelected);
    }));

    // this.matSelectFilter.valueChange.subscribe((filter) => {
    // Abstract actions are for ODP Supervisor only
    // Commented out for testing
    // if (this.accountService.IsOdpSupervisorRole()) {
    // });
  }

  checkAbstractForCodingBeforeNavigate(abstractId: string, projectTitle: string) {
    console.log(`current view is staff: ${this.isStaffView}`);
    //event.stopPropagation();

    var currentRole = this.accountService.GetActiveRole();

    if (currentRole == Roles.ReconciliationCoder || currentRole == Roles.ReconciliationSupervisor) {
      this.checkIfAbstractBeingCoded(abstractId, projectTitle);
    }
    else {
      window.open(`#/abstract/view/${abstractId}`, "_blank");
    }
  }

  public clearSearchTerm() {
    this.searchTerm = "";
    this.abstractSearchKeys.abstractEnteredSearchFilter = "";
    this.loadAbstractData(this.protocolSelected);
    //this.buildQcSelectPoolMechs();
  }

  public checkIfAbstractBeingCoded(abstractId: string, projectTitle: string) {

    this.alertService.startLoadingMessage();
    this.loadingIndicator = true;
    this.isLoadingResults = true;

    if (this.accountService.GetActiveTeam() && this.accountService.GetActiveTeam().teamId > 0 && this.accountService.GetActiveRole() != Roles.ReconciliationSupervisor) {
      var absIdInt = parseInt(abstractId);

      this.abstractService.getOpenAbstract(this.accountService.GetActiveRole(), this.accountService.GetActiveTeam() ? this.accountService.GetActiveTeam().teamId : 0, absIdInt)
        .subscribe({ next: abstractInCoding => {
          this.alertService.stopLoadingMessage();
          this.loadingIndicator = false;

          if (abstractInCoding && abstractInCoding.abstractId && abstractInCoding.abstractId != null && abstractInCoding.abstractId != 0) {
            if (abstractInCoding.abstractId == abstractId) {
              window.open(`#/abstract/view/${abstractId}`, "_blank");
            }
            else {
              //TODO
              this.alertService.stopLoadingMessage();

              let message = 'A team member has already opened another abstract for Coding. You will be redirected to Abstract &nbsp;<i>"' + abstractInCoding.abstract.projectTitle + '"</i>';

              this.openDecisionBottomSheet('Other opened abstract for coding', message, abstractInCoding.abstractId);

              this.loadingIndicator = false;
              this.isLoadingResults = false;

            }
          }
          else {
            window.open(`#/abstract/view/${abstractId}`, "_blank");
          }



        }, error: error => {
            this.alertService.stopLoadingMessage();
            this.loadingIndicator = false;
            this.alertService.showStickyMessage("Load Error", `Unable to retrieve abstracts from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
              MessageSeverity.error, error);
          }});
    }
    else {
      this.alertService.stopLoadingMessage();
      window.open(`#/abstract/view/${abstractId}`, "_blank");
    }
  }

  openDecisionBottomSheet(sheetTitle: string, sheetText: string, abstractId: number): void {

    this.bottomSheet.open(DecisionBottomSheetComponent, {
      data: {
        sheetTitle: sheetTitle,
        sheetHtml: sheetText
      },
      closeOnNavigation: true
    }).afterDismissed().subscribe(isOk => {
      if (isOk) {
        window.open(`#/abstract/view/${abstractId}`, "_blank");
      }
    });
  }

  buildQcSelectPoolMechs() {
    /// get the FULL FILTERED abstract result (not just page size N for table display)
    /// to build QC Eligible pool and mechanisms for random selection

    this.abstractService.getAbstractsByParamsRecon(this.abstractSearchKeys).pipe(takeUntil(this.destroy$)).subscribe({ next: abstractsFull => {
        this.alertService.stopLoadingMessage();
        this.loadingIndicator = false;
        this.isLoadingResults = false;
        this.isRateLimitReached = false;
        this.abProIdsFullQCEligPoolCurrent = []; /// reset abProIdsFullQCEligPoolCurrent to rebuild with latest result set
        this.qcMechGrps = []; /// reset qcMechGrps to rebuild with latest result set

        abstractsFull.abstractResult.forEach((abst) => {

          var notes = abst.coderNotes;

          /// Exclude abstracts in Coder Q list (reviewRecommended) from QC eligible pool
          if (!abst.reviewRecommended) {
            this.abProIdsFullQCEligPoolCurrent.push(abst.abstractProtocolId);

            /// Parse full result of AbstractKappas into mechanismgroups for random sampling
            let item: MechGrpItem = {
              title: abst.mechanism,
              rate: abst.samplingRate,
              ingrpcount: 1,
              ingrpabpros: [],
              sampleN: 1,
              qcselectedcount: 0
            };
            if (this.qcMechGrps.length > 0) {
              var grpfound = 0;
              this.qcMechGrps.forEach((grp) => {
                if (grp.title == item.title) {
                  grp.ingrpabpros.push(abst);
                  grp.ingrpcount++;
                  grp.sampleN = Math.round(grp.ingrpcount * (grp.rate / 100));
                  if (grp.sampleN < 1) { grp.sampleN = 1 };
                  grpfound = 1;
                };
              })
              if (grpfound == 0) {
                item.ingrpabpros.push(abst);
                this.qcMechGrps.push(item);
              }
            }
            else {
              item.ingrpabpros.push(abst);
              this.qcMechGrps.push(item);
            }

          };

        });

        var sbct2 = this.qcMechGrps;
      }, error: error => {
          this.alertService.stopLoadingMessage();
          this.loadingIndicator = false;
          this.alertService.showStickyMessage('Filtered Full Load Error',
            `Unable to retrieve abstracts from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
            MessageSeverity.error, error);
        }});

  }

  buildExcludeCoderOptions() {
    /// get the FULL UNFILTERED abstract result (not just page size N for table display)
    /// to get coding teams, to build list of coders for exclusion ddl options

    if (this.westatCoders.length <= 0) {
      var unfilteredSearchKeys = new AbstractSearchKeys();
      unfilteredSearchKeys.pageSize = this.abstractSearchKeys.pageSize;
      unfilteredSearchKeys.pageNumber = this.abstractSearchKeys.pageNumber;
      unfilteredSearchKeys.abstractFilterType = this.abstractSearchKeys.abstractFilterType;
      unfilteredSearchKeys.sortColumnName = this.abstractSearchKeys.sortColumnName;
      unfilteredSearchKeys.sortDirection = this.abstractSearchKeys.sortDirection;
      unfilteredSearchKeys.protocolId = this.abstractSearchKeys.protocolId;
      unfilteredSearchKeys.filterByProtocol = this.abstractSearchKeys.filterByProtocol;
      //this.abProIdsFullForQCReset = [];

      this.abstractService.getAbstractsByParamsRecon(unfilteredSearchKeys).pipe(takeUntil(this.destroy$)).subscribe({ next: abstractsUnfilteredFull => {
        this.alertService.stopLoadingMessage();
        this.loadingIndicator = false;
        this.isLoadingResults = false;
        this.isRateLimitReached = false;

        abstractsUnfilteredFull.abstractResult.forEach((abst) => {

          /// Get teams to get users for "exclude users" ddl - ONLY when user list is NOT already filtered
          /// If teams list is reset while users are excluded, those users cannot be unselected from the exclude list
          if (this.abstractTeams.length < 1 || !this.abstractTeams.includes(abst.coderTeamId)) {
            this.abstractTeams.push(abst.coderTeamId);
          }

        });

        /// Get coders on teams to get users for "exclude users" ddl - ONLY include users who are also in ReconciliationCoder role
        this.accountService.getWestatCoders(this.abstractTeams).subscribe({ next: westatCodersResult => {

          westatCodersResult.forEach((user) => {
            if (user.roles.toString().toLowerCase().includes("reconciliationcoder") && user.isEnabled) {
              this.westatCoders.push(user);
            }
          });

        }, error: error => {
            this.alertService.showStickyMessage(
              'Westat Coder List Load Error',
              `Unable to retrieve coders result from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
              MessageSeverity.error, error);
          }});
      }, error: error => {
          this.alertService.stopLoadingMessage();
          this.loadingIndicator = false;
          this.alertService.showStickyMessage('Unfiltered Full Load Error',
            `Unable to retrieve abstracts from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
            MessageSeverity.error, error
          );
        }});
    }
  }


  loadAbstractData(protocolId) {
    if (this.loadAbstractDataSubTrack !== null) {
      this.loadAbstractDataSubTrack.unsubscribe();
      this.alertService.stopLoadingMessage();
      this.loadAbstractDataSubTrack = null;
    }

    this.alertService.startLoadingMessage();
    this.isLoadingResults = true;
    var selectedabs = this.selection.selected;

    this.abstractSearchKeys.protocolId = protocolId;
    this.abstractSearchKeys.filterByProtocol = this.filterByProtocol;

    /// Get abstracts for display in view list (10 or selected N)
    this.loadAbstractDataSubTrack = this.abstractService.getAbstractsByParamsRecon(this.abstractSearchKeys).pipe(takeUntil(this.destroy$)).subscribe({ next: abstractsData => {
      this.alertService.stopLoadingMessage();
      this.loadingIndicator = false;
      this.isLoadingResults = false;
      this.isRateLimitReached = false;

      this.abstractsData = abstractsData;
      this.dataSource = abstractsData.abstractResult;
      this.rowData = this.dataSource;
      // Setting Eligible Count before calculating potential auto sample percentage
      this.eligibleAbstractsWithMlDataCount = this.abstractsData.highPriDisagreementCount + this.abstractsData.lowPriDisagreementCount + this.abstractsData.fullAgreementCount;      
      this.highDisagreePercentUpdate();
      this.lowDisagreePercentUpdate();
      this.fullAgreePercentUpdate();
      this.updateCurrentSampledValues();

      if (this.activeActionName != "") {
        switch (this.activeActionName) {
          case "addreview":
            this.manualActionSnackBarText = (this.abstractsData.inQCListCount - this.currentFiltReconciliationCount).toString() + " abstract(s) were added to Reconciliation list.";
            break;
          case "removereview":
            this.manualActionSnackBarText = (this.currentFiltReconciliationCount - this.abstractsData.inQCListCount).toString() + " abstract(s) were removed from Reconciliation list.";
            break;
          case "addcoderq":
            this.manualActionSnackBarText = (this.abstractsData.inCoderQListCount - this.currentFiltCoderqCount).toString() + " abstract(s) had the QC Coder Question option set and were added to the Reconciliation list.";
            break;
          case "removecoderq":
            this.manualActionSnackBarText = (this.currentFiltCoderqCount - this.abstractsData.inCoderQListCount).toString() + " abstract(s) had the QC Coder Question option unset and were removed from the Reconciliation list.";
            break;
          case "addadjudication":
            this.manualActionSnackBarText = (this.abstractsData.inODPAdjudicationCount - this.currentFiltODPAdjuCount).toString() + " abstract(s) had the Request ODP Adjudication option set.";
            break;
          case "removeadjudication":
            this.manualActionSnackBarText = (this.currentFiltODPAdjuCount - this.abstractsData.inODPAdjudicationCount).toString() + " abstract(s) had the Request ODP Adjudication option unset.";
            break;
        }
        if (this.manualActionSnackBarText != "") {
          this.openSnackBar(this.manualActionSnackBarText, "Dismiss");
          this.manualActionSnackBarText = "";
        }
        this.activeActionName = "";
      }
      if (this.isAutoSampling) {
        this.isAutoSampling = false;
        this.autoSampleHighPriDisagreeResultCount = this.abstractsData.highPriDisagreementReconCount;
        this.autoSampleLowPriDisagreeResultCount = this.abstractsData.lowPriDisagreementReconCount;
        this.autoSampleFullAgreeResultCount = this.abstractsData.fullAgreementReconCount;
        this.actualAbstractsInReconWithMlDataCount = this.abstractsData.highPriDisagreementReconCount + this.abstractsData.lowPriDisagreementReconCount + this.abstractsData.fullAgreementReconCount;
        this.openSnackBar("Auto-Sampling completed.  The Reconciliation List has been updated.", "Dismiss", 15);
      }
      else {
        this.clearActualReconCountData();
      }

      /*abstractsData.coderResult.forEach((user) => {
        if (user.roles.toString().toLowerCase().includes("reconciliationcoder") && user.isEnabled) {
          this.westatCoders.push(user);
        }
      });*/

      /// Get filters and filtered counts, if any
      ////////////////// Reset select list options and messages for filtered/unfiltered counts
      this.filteroptions.forEach((opt) => {

        var thisoptname = opt.name;
        var currListName = '';
        var filtListCount = 0;
        var unfiltListCount = 0;
        var isfiltcnt = 0;
        var updmenuoption;
        var menuoptionindex;

        switch (thisoptname) {
          case 'qceligible': {
            filtListCount = this.abstractsData.reconEligibleCount;
            unfiltListCount = this.unfiltAllCount;
            break;
          }
          case 'qceligiblereview': {
            filtListCount = this.abstractsData.inQCListCount;
            unfiltListCount = this.unfiltReconciliationCount;
            break;
          }
          case 'qceligiblecoderqrev': {
            filtListCount = this.abstractsData.inCoderQListCount;
            unfiltListCount = this.unfiltCoderqCount;
            break;
          }
          case 'qceligiblecoderodpadju': {
            filtListCount = this.abstractsData.inODPAdjudicationCount;
            unfiltListCount = this.unfiltODPAdjuCount;
          }
          default: {
            break;
          }
        };

        if (filtListCount < unfiltListCount) {
          isfiltcnt = 1;
        }
        updmenuoption = opt;
        menuoptionindex = this.filteroptions.findIndex(o => o.name.toLowerCase().includes(thisoptname));
        ////currListName = updmenuoption.displayText.replace(" (" + unfiltListCount + ")", "").replace(" (" + filtListCount + ")", "").replace("*", "");
        currListName = updmenuoption.displayText.substring(0, updmenuoption.displayText.indexOf("(") - 1);
        ////currListName = updmenuoption.displayText.replace("*", "");

        updmenuoption.displayText = currListName
        /*if (isfiltcnt == 1) {
          //Removing '*' for now 
          //updmenuoption.displayText = currListName + " (" + filtListCount + ")*"
          updmenuoption.displayText = currListName + " (" + filtListCount + ")";
          if (this.filterOptionSelected == opt.name) {
            this.isFiltCountAlert = true;
            this.qcFilterCountsDisplayText = "* Note: the current filters include " + filtListCount.toString() + " of the " + unfiltListCount.toString() + "  " + currListName + " abstracts in the database. To see all " + unfiltListCount.toString() + "  " + currListName + " abstracts, expand the date range and/or include all coders."
          }
        } else {
          updmenuoption.displayText = currListName + " (" + opt.recordsAmount + ")"
          if (this.filterOptionSelected == opt.name) {
            this.qcFilterCountsDisplayText = ""
          }
        }*/

        // Code was not using updated Recon List Count unless it was less than the count of the Recon List when the page was initially loaded
        updmenuoption.displayText = currListName + " (" + filtListCount + ")";
        if (this.filterOptionSelected == opt.name) {
          this.isFiltCountAlert = true;
          this.qcFilterCountsDisplayText = ""
        }
        this.filteroptions.splice(menuoptionindex, 1, updmenuoption);
      });
      ////////////////// END eset select list options and messages for filtered/unfiltered counts


      if (this.abstractSearchKeys.excludedUsers.length > 0 || this.abstractSearchKeys.qcWeek != null) {
        this.qcViewFiltered = true;
        var exclUserNames = "";
        var weekText = "";
        this.qcFiltersDisplayText = "Filters Applied: ";
        if (this.abstractSearchKeys.excludedUsers.length > 0) {
          this.westatCoders.forEach((coder) => {
            if (this.selectedCoders.indexOf(parseInt(coder.id)) > -1) {
              if (exclUserNames == "") {
                exclUserNames += "Exclude Coders " + coder.firstName + " " + coder.lastName;
              }
              else {
                exclUserNames += ", " + coder.firstName + " " + coder.lastName;
              }
            }
          });
        };
        if (this.abstractSearchKeys.qcWeek != null) {
          weekText += "Week " + this.abstractSearchKeys.qcWeek;
        };
        if (exclUserNames != "") { this.qcFiltersDisplayText += (weekText != "") ? exclUserNames + "; " : exclUserNames };
        if (weekText != "") { this.qcFiltersDisplayText += weekText };

        if ((this.abstractsData.reconEligibleCount < this.unfiltAllCount) || (this.abstractsData.inQCListCount < this.unfiltReconciliationCount) || (this.abstractsData.inCoderQListCount < this.unfiltCoderqCount)) {
          this.isFiltCountAlert = true;

        }

      } else {
        if (!this.isFiltCountAlert) {
          this.qcViewFiltered = false;
          this.qcFilterCountsDisplayText = ""
          this.qcFiltersDisplayText = ""
        }
      };
    }, error: error => {
        this.alertService.stopLoadingMessage();
        this.loadingIndicator = false;
        if (this.isAutoSampling) {
          this.isAutoSampling = false;
        }
        this.alertService.showStickyMessage('List View Load Error',
          `Unable to retrieve abstracts from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
          MessageSeverity.error, error);
      }});

    selectedabs.forEach((selab) => {
      this.selection.deselect(selab);
    })

  }

  public filterByProtocolChange(event: any) {
    console.log(event);
    this.subject.next(this.searchTerm);
    //this.buildQcSelectPoolMechs();
  }

  public searchTermChange(event: any) {
    this.searchTerm = event.target.value;
    var trimmedTerm = this.searchTerm.trim();
    //This is to delay the load abstract execution until user stops typing
    this.abstractSearchKeys.abstractEnteredSearchFilter = trimmedTerm;
    this.subject.next(trimmedTerm);
    //this.buildQcSelectPoolMechs();
  }

  public excludeUsers(event: any) {
    this.abstractSearchKeys.excludedUsers = this.selectedCoders;
    if (JSON.stringify(this.selectedCoders) != JSON.stringify(this.oldSelectedCoders)) {
      // This needs to be updated so that the check between the current and previous is accurate
      this.oldSelectedCoders = this.selectedCoders;
      this.loadAbstractData(this.protocolSelected);
    }
    //this.buildQcSelectPoolMechs();
  }

  public updateDateRange(event: any) {
    this.invalidEndDate = false;
    if (this.selectedWeek) {
      this.abstractSearchKeys.qcWeek = this.selectedWeek.qcWeek;
    }
    else {
      this.abstractSearchKeys.qcWeek = null;      
    }
    // Clearing excluded coders list when user changes week
    this.selectedCoders = [];
    this.oldSelectedCoders = [];
    this.abstractSearchKeys.excludedUsers = [];
    this.loadAbstractData(this.protocolSelected);
    //this.buildQcSelectPoolMechs();
  }

  //loads the metadata of the abstract search page
  public loadAbstractSearchMetaData(protocolId) {
    this.alertService.startLoadingMessage();
    this.loadingIndicator = true;

    this.abstractService.getAbstractSearchMetadata(this.accountService.GetActiveRole(), protocolId, this.accountService.GetActiveProject().odpProjectWorkflowId, true)
      .subscribe({ next: metadata => {
        this.alertService.stopLoadingMessage();
        this.loadingIndicator = false;
        this.metadata = metadata; //Make it local scope so other functions can utilize it 
        this.processMetadata();
        this.loadAbstractData(this.protocolSelected);
        //this.buildQcSelectPoolMechs();
        //this.buildExcludeCoderOptions();
      }, error: error => {
          this.alertService.stopLoadingMessage();
          this.loadingIndicator = false;
          this.alertService.showStickyMessage("Search Metadata Load Error", `Unable to retrieve abstracts from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
            MessageSeverity.error, error);
        }});
  }

  //// (re-)initializes AbstractSearchMetadata
  public initializeAbstractSearchMetadata() {
    /// Instead of letting user select a protocol, we are now getting it from the selected active project
    this.protocolSelected = this.accountService.GetActiveProject().protocolId;
    this.loadAbstractSearchMetaData(this.protocolSelected);
    //this.protocolService.getProtocols().subscribe({ next: protocolResult => {
    //  this.protocols = protocolResult;
    //  if (protocolResult.length > 0) {
    //    var protocolSelectedObject = protocolResult.find(p => p.isDefault == true)
    //    if (protocolSelectedObject) {
    //      this.protocolSelected = protocolSelectedObject.id;
    //      this.protocolSelectedTitle = protocolSelectedObject.title;
    //      this.loadAbstractSearchMetaData(this.protocolSelected);
    //    }
    //  }
    //}, error: error => {
    //    this.alertService.showStickyMessage(
    //      'Protocol Load Error',
    //      `Unable to retrieve protocols from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
    //      MessageSeverity.error, error);
    //  }});
  }


  ////Load actions for the action list Select based on the filter Select selection 
  public loadActions(actionType: string, recordsAmount: number) {
    //Actions are only for user with Role ODPSupervisor
    if (recordsAmount != 0 && this.isSupervisorView) {  //&& this.isOdpSupervisor
      this.actionoptions = [];
      this.actionOptionSelected = "";
      if (this.metadata.menuActionOptions && this.metadata.menuActionOptions.length > 0) {
        this.metadata.menuActionOptions.forEach((action: MenuActionOption) => {
          if (action.filterOption == actionType) {
            let option: GenericSelectOption = {
              name: action.name,
              displayText: action.displayText,
              statusIds: "",
              recordsAmount: 0
            };
            if (actionType == "qceligiblereview") {
              if (action.name == 'selectaction' || action.name == 'removereview' || action.name == 'exportabstracts') { this.actionoptions.push(option); }
            }
            else if (actionType == "qceligiblecoderqrev") {
              if (action.name == 'selectaction' || action.name == 'removecoderq' || action.name == 'exportabstracts' || action.name == 'addreview' || action.name == 'removereview') { this.actionoptions.push(option); }
            }
            else {
              this.actionoptions.push(option);
            }
          }
        });
      }
    }
    else {
      this.actionoptions = [];
      this.actionOptionSelected = "";
    }
  }

  //Process data for the Filters list Select 
  public processMetadata() {
    this.filteroptions = [];
    this.highPriDisagreementSamplePercent = this.metadata.highPriDisagreementBasePercent;
    this.lowPriDisagreementSamplePercent = this.metadata.lowPriDisagreementBasePercent;
    this.fullAgreementSamplePercent = this.metadata.fullAgreementBasePercent;
    var currentfilter = this.filterOptionSelected;
    this.qcAltView1DisplayText = "";
    this.qcAltView2DisplayText = "";
    if (this.isSupervisorView && this.isOdpSupervisor) {
      this.metadata.menuFilterOptions.forEach((filter: MenuFilterOption) => {
        if (filter.userType == "ODPSupervisor") {
          let option: GenericSelectOption = {
            name: filter.filterOption,
            displayText: filter.displayText + " (" + filter.recordsAmount + ")",
            statusIds: filter.statusId,
            recordsAmount: filter.recordsAmount
          };

          /// [Notes:BJL_2023-08-02] Fix Abstract List filter handling
          /// * Originally, the following statements always reset the current filter
          /// to the default option ("all") after an action.
          /// * If another filter option was already selected, this caused a mismatch
          /// between the apparent selected filter option and the filtered results.
          /// * For example, if the user was viewing "In Review List" abstracts and
          /// removed one from the review list, that action would reset the filter to
          /// display "All Abstracts", but the results would still show only the remaining
          /// review list abstracts.
          /// * These statements also unnecessarily set the search keys and called "loadActions"
          /// after every filter option added to the filter list, not just the currently selected
          /// one, and always called "loadActions" for the "all" option.
          /// * To fix this, I included a check for the current filter; if it is null (as on initial
          /// page load), the selection is set to "all" and the search keys and load actions are
          /// set to the "all" option; otherwise these are set to the currently selected filter.
          /// * I did the same in the clauses for other roles below, which have different defaults.

          var defaultName = "qceligible";
          if (option.name == "qceligible" || option.name == "qceligiblereview" || option.name == "qceligiblecoderqrev" || option.name == "qceligiblecoderodpadju") {
            this.filteroptions.push(option);

            if (option.name == "qceligible") {
              this.unfiltAllCount = option.recordsAmount;
              if (this.qcAltView1DisplayText == "") { this.qcAltView1DisplayText = option.displayText; };
            };
            if (option.name == "qceligiblecoderqrev") {
              this.unfiltCoderqCount = option.recordsAmount;
              if (this.qcAltView2DisplayText == "") { this.qcAltView2DisplayText = option.displayText; };
            }
            if (option.name == "qceligiblereview") {
              this.unfiltReconciliationCount = option.recordsAmount;
              if ((currentfilter == "qceligible") || (currentfilter == "")) {
                this.qcAltView1DisplayText = option.displayText;
              } else if (currentfilter == "qceligiblecoderqrev") {
                this.qcAltView2DisplayText = option.displayText;
              };
            };
            if (option.name == "qceligiblecoderodpadju") {
              this.unfiltODPAdjuCount = option.recordsAmount;
              if (this.qcAltView1DisplayText == "") { this.qcAltView1DisplayText = option.displayText; };
            };
            if (currentfilter == "qceligiblereview") {
              this.qcViewQcList = true;
              this.qcViewCoderQList = false;
            } else if (currentfilter == "qceligiblecoderodpadju") {
              this.qcViewQcList = false;
              this.qcViewCoderQList = true;
            } else {
              this.qcViewQcList = false;
              this.qcViewCoderQList = false;
            };
          };
          if ((currentfilter == "" && option.name == defaultName) || (option.name == currentfilter)) {
            this.filterOptionSelected = option.name;
            this.abstractSearchKeys.abstractFilterType = option.statusIds;
            this.loadActions(this.filterOptionSelected, option.recordsAmount);
          }
        }
      });
    }
    else {
      if (this.isStaffView && this.isOdpStaff) {
        this.metadata.menuFilterOptions.forEach((filter: MenuFilterOption) => {
          if (filter.userType == "ODPStaff") {
            let option: GenericSelectOption = {
              name: filter.filterOption,
              displayText: filter.displayText + " (" + filter.recordsAmount + ")",
              statusIds: filter.statusId,
              recordsAmount: filter.recordsAmount
            };
            this.filteroptions.push(option);
            /// [Notes:BJL_2023-08-02] Fix Abstract List filter handling
            /// * See related notes in initial if clause above.
            if ((currentfilter == "" && option.name == "review") || (option.name == currentfilter)) {
              this.filterOptionSelected = option.name;
              this.abstractSearchKeys.abstractFilterType = option.statusIds;
              this.abstractSearchKeys.isInReview = true;
            }
          }
        });
      }
      else {
        if (this.isSupervisorView && this.isCoderSupervisor) {
          this.metadata.menuFilterOptions.forEach((filter: MenuFilterOption) => {
            if (filter.userType == "CoderSupervisor") {
              let option: GenericSelectOption = {
                name: filter.filterOption,
                displayText: filter.displayText + " (" + filter.recordsAmount + ")",
                statusIds: filter.statusId,
                recordsAmount: filter.recordsAmount
              };
              this.filteroptions.push(option);
              /// [Notes:BJL_2023-08-02] Fix Abstract List filter handling
              /// * See related notes in initial if clause above.
              if ((currentfilter == "" && option.name == "default") || (option.name == currentfilter)) {
                this.filterOptionSelected = option.name;
                this.abstractSearchKeys.abstractFilterType = option.statusIds;
              }
            }
          });
        }
        else {
          if (this.isStaffView && this.isCoder) {
            this.metadata.menuFilterOptions.forEach((filter: MenuFilterOption) => {
              if (filter.userType == "Coder") {
                let option: GenericSelectOption = {
                  name: filter.filterOption,
                  displayText: filter.displayText + " (" + filter.recordsAmount + ")",
                  statusIds: filter.statusId,
                  recordsAmount: filter.recordsAmount
                };
                this.filteroptions.push(option);
                /// [Notes:BJL_2023-08-02] Fix Abstract List filter handling
                /// * See related notes in initial if clause above.
                if ((currentfilter == "" && option.name == "odpcompleted") || (option.name == currentfilter)) {
                  this.filterOptionSelected = option.name;
                  this.abstractSearchKeys.abstractFilterType = option.statusIds;
                  this.abstractSearchKeys.isInReview = true;
                }
              }
            });
          }
          else {
            this.metadata.menuFilterOptions.forEach((filter: MenuFilterOption) => {
              if (filter.userType == "Admin") {
                let option: GenericSelectOption = {
                  name: filter.filterOption,
                  displayText: filter.displayText + " (" + filter.recordsAmount + ")",
                  statusIds: filter.statusId,
                  recordsAmount: filter.recordsAmount
                };
                this.filteroptions.push(option);
                /// [Notes:BJL_2023-08-02] Fix Abstract List filter handling
                /// * See related notes in initial if clause above.
                if ((currentfilter == "" && option.name == "default") || (option.name == currentfilter)) {
                  this.filterOptionSelected = option.name;
                  this.abstractSearchKeys.abstractFilterType = option.statusIds;
                }
              }
            });
          }
        }
      }
    }
  }

  public filterSelected(selectedOption: GenericSelectOption) {
    this.abstractSearchKeys.isInReview = false;
    this.abstractSearchKeys.recommendedForReview = false;
    this.abstractSearchKeys.isReportExcluded = false;
    this.abstractSearchKeys.recommendedForAdjudication = false;
    if (selectedOption.name.toLowerCase().includes('review')) {
      this.abstractSearchKeys.isInReview = true;
    }
    if (selectedOption.name.toLowerCase().includes('coderq')) {
      this.abstractSearchKeys.recommendedForReview = true;
    }
    if (selectedOption.name.toLowerCase().includes('report')) {
      this.abstractSearchKeys.isReportExcluded = true;
    }
    if (selectedOption.name.toLowerCase().includes('coderodpadju')) {
      this.abstractSearchKeys.recommendedForAdjudication = true;
    }

    /*this.selectedCoders = [];
    this.abstractSearchKeys.excludedUsers = [];
    this.selectedWeek = null;
    this.abstractSearchKeys.qcWeek = null;
    this.invalidEndDate = false;*/

    // Clearing excluded coders list when moving away from qceligible
    if (selectedOption.name != 'qceligible') {
      this.selectedCoders = [];
      this.oldSelectedCoders = [];
      this.abstractSearchKeys.excludedUsers = [];
    }

    this.abstractSearchKeys.excludeAbstractsRecommendedForReview = false;
    this.abstractSearchKeys.excludeAbstractsInQcList = false;
    this.colDefs = this.colDefsQcEligibleFilter;

    this.abstractSearchKeys.abstractFilterType = selectedOption.statusIds;
    this.abstractSearchKeys.pageNumber = 0;
    this.paginator.forEach(p => p.pageIndex = 0);

    this.loadActions(selectedOption.name, selectedOption.recordsAmount);
    this.clearSearchTerm(); // Runs loadAbstractData()
  }


  public submitAction() {

    this.isLoadingResults = true;
    var selectedabscount = 0;
    var selectedabstrs = this.selection.selected;
    var abstractProtocolIds = [];

    this.currentFiltReconciliationCount = this.abstractsData.inQCListCount;
    this.currentFiltCoderqCount = this.abstractsData.inCoderQListCount;
    this.currentFiltODPAdjuCount = this.abstractsData.inODPAdjudicationCount;

    this.selection.selected.forEach((selab) => {
      abstractProtocolIds.push(selab.abstractProtocolId);
      selectedabscount++;
    });

    if (this.actionOptionSelected == "exportabstracts") {
      this.exportQcCoderQListAsXLSX();
      this.loadingIndicator = false;
      this.isLoadingResults = false;
      this.isRateLimitReached = false;
      this.clearSelected(selectedabstrs);
      //});
      return;
    };

    if (this.actionOptionSelected == "addreview" || this.actionOptionSelected == "addcoderq" || this.actionOptionSelected == "addadjudication") {
      var notprocessed = 0;
      var notprocmsg = "";
      var optionWarningTitle = "";
      this.selection.selected.forEach((selab) => {
        if ((this.actionOptionSelected == "addreview" && selab.inReviewList) || (this.actionOptionSelected == "addcoderq" && selab.reviewRecommended)
          || (this.actionOptionSelected == "addadjudication" && selab.adjudicationRecommended)) {
          notprocessed++;
        };
      });
      if (notprocessed > 0) {
        var remainabscount = selectedabscount - notprocessed        
        if (notprocessed == 1) {
          notprocmsg = "PLEASE NOTE: " + (remainabscount > 0 ? notprocessed : "The") + " abstract selected is already ";
        } else {
          notprocmsg = "PLEASE NOTE: " + (remainabscount > 0 ? notprocessed : "All") + " abstracts selected are already ";
        };
        if (this.actionOptionSelected == "addreview") {
          notprocmsg += "in the Reconciliation List, and will not be processed.";
          optionWarningTitle = "Add to Reconciliation List";
        }
        else if (this.actionOptionSelected == "addcoderq") {
          notprocmsg += "flagged with QC Coder Question, and will not be processed.";
          optionWarningTitle = "Flag with QC Coder Question";
        }
        else if (this.actionOptionSelected == "addadjudication") {
          notprocmsg += "set with the ODP Adjudication option enabled, and will not be processed."
          optionWarningTitle = "Enable ODP Adjudication Option";
        }

        if (remainabscount > 0) {
          if (this.actionOptionSelected == "addreview") {
            notprocmsg += " Do you want to add the remaining " + remainabscount + "  abstract(s) to the Reconciliation List?";
          }
          else if (this.actionOptionSelected == "addcoderq") {
            notprocmsg += " Do you want to flag the remaining " + remainabscount + "  abstract(s) with QC Coder Question?";
          }
          else if (this.actionOptionSelected == "addadjudication") {
            notprocmsg += " Do you want to enable the ODP Adjudication option on the remaining " + remainabscount + "  abstract(s)?"
          }

          this.bottomSheet.open(DecisionBottomSheetComponent, {
            data: {
              sheetTitle: optionWarningTitle,
              sheetHtml: notprocmsg
            }
          }).afterDismissed().subscribe(isOk => {
            if (isOk) {
              this.processSubmit(abstractProtocolIds);
              this.clearSelected(selectedabstrs);
            };
          });
        } else {
          this.bottomSheet.open(ConfirmBottomSheetComponent, {
            data: {
              sheetTitle: optionWarningTitle,
              buttonText: "OK",
              sheetHtml: notprocmsg
            },
            closeOnNavigation: true
          });
        };
      } else {
        this.processSubmit(abstractProtocolIds);
        this.clearSelected(selectedabstrs);
      };
    } else {
      this.processSubmit(abstractProtocolIds);
      this.clearSelected(selectedabstrs);
    };    

    this.activeActionName = this.actionOptionSelected;
    this.loadingIndicator = false;
    this.isLoadingResults = false;
    this.isRateLimitReached = false;

    /* };*/

  }

  public processSubmit(abstractProtocolIds) {
    let actionAbstracts: ActionAbstracts = {
      actionType: this.actionOptionSelected,
      abstractProtocolIds: abstractProtocolIds
    };

    this.abstractService.changeAbstractsStatus(actionAbstracts, this.accountService.GetActiveProject().odpProjectWorkflowId)
      .subscribe({
        next: abstractsResult => {
        this.alertService.stopLoadingMessage();
        if (abstractsResult) {
          this.loadAbstractSearchMetaData(this.protocolSelected);
        }
        this.loadingIndicator = false;
        this.isLoadingResults = false;
        this.isRateLimitReached = false;
      }, error: error => {
          this.alertService.stopLoadingMessage();
          this.loadingIndicator = false;
          this.alertService.showStickyMessage("Submit Action Error", `Unable to retrieve abstracts from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
            MessageSeverity.error, error);
        }});

  }

  public clearSelected(selectedabstrs) {

    ///// [Notes:BJL_2023-08-02]  Fix Abstract List filter handling
    /////The array "this.selection.selected" defines the abstracts to perform an action on.
    ///// * Originally, the array persisted after an action was performed, and abstracts selected for the next action
    ///// were added to the existing array. It was unclear when and how the array was reset. 
    ///// * This caused the following error when multiple actions were performed on a given abstract (e.g. adding an 
    ///// abstract to the review list, and then removing it):
    /////   "System.InvalidOperationException: 'The instance of entity type 'AbstractProtocol' cannot be tracked because
    /////   another instance with the same key value for { 'Id'} is already being tracked."
    ///// * This also caused actions to be performed on the wrong abstracts - for example, when abstracts were added 
    ///// to the review list, and then other abstracts were removed, the correctly-added ones were still in the array, 
    ///// and were also removed.
    ///// * To fix this, I added the code below, to remove all items from "this.selection.selected" after an action.
    selectedabstrs.forEach((selab) => {
      this.selection.deselect(selab);
    });

  }

  public autoSampleAbstracts() {
    this.bottomSheet.open(DecisionBottomSheetComponent, {
      data: {
        sheetTitle: "Confirm Update to Reconciliation List",
        sheetHtml: "This will clear all abstracts auto sampled and manually added for the selected week. Are you sure you to want to auto sample abstracts for the selected week?"
      }
    }).afterDismissed().subscribe(isOk => {
      if (isOk) {
        this.alertService.startLoadingMessage();
        this.isLoadingResults = true;
        this.isAutoSampling = true;

        /// Get abstracts for display in view list (10 or selected N)
        this.abstractService.autoSampleAbstracts(this.abstractSearchKeys).subscribe({ next: autoSampleResult => {
          this.alertService.stopLoadingMessage();
          this.loadingIndicator = false;
          this.autoSampleResult = autoSampleResult;
          this.loadAbstractData(this.protocolSelected);
        }, error: error => {
            this.alertService.stopLoadingMessage();
            this.loadingIndicator = false;
            this.isAutoSampling = false;
            this.alertService.showStickyMessage('Auto Sample Error',
              `Unable to auto sample abstracts from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
              MessageSeverity.error, error);
          }});
      }
    });
  }

  /// [Notes:BJL_2024-05-23]  Open all abstracts in QC or Coder Q list for print to pdf
  public openPrintPdfWindow() {
    var keys = this.abstractSearchKeys;
    if (keys.qcWeek) {
      window.open(`#/abstract/print/0/${keys.abstractFilterType}/${keys.filterByProtocol}/${keys.isInReview}/${keys.recommendedForReview}/${keys.isReportExcluded}/${keys.protocolId}/${keys.sortColumnName}/${keys.sortDirection}/${keys.qcWeek}`, "_blank");
    }
    else {
      window.open(`#/abstract/print/0/${keys.abstractFilterType}/${keys.filterByProtocol}/${keys.isInReview}/${keys.recommendedForReview}/${keys.isReportExcluded}/${keys.protocolId}/${keys.sortColumnName}/${keys.sortDirection}`, "_blank");
    }
  }



  //not used
  public actionChange(action: any) {

    //console.log(action)
    //console.log(this.selection)

    //console.log(this.selection.selected)

    ////this.isLoadingResults = true;

    //var abstractIds = [];
    //this.selection.selected.forEach(function (obj) {
    //  console.log(obj)
    //  abstractIds.push(obj.abstractId);
    //})

    //let actionAbstracts: ActionAbstracts = {
    //  actionType: action,
    //  abstractProtocolIds: abstractIds
    //};
    //console.log(actionAbstracts)
  }

  public highlight(row) {
    this.selectedRowIndex = row.abstractId;
    console.log(row)
  }

  /** Whether the number of selected elements matches the total number of rows. */
  public isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  public masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.forEach(row => this.selection.select(row));
  }

  public highDisagreePercentUpdate() {
    this.abstractSearchKeys.highPriDisagreementSamplePercent = this.highPriDisagreementSamplePercent;
    this.highPriDisagreeAutoCount = Math.round(this.abstractsData.highPriDisagreementCount * (this.highPriDisagreementSamplePercent / 100));
    this.updateSampleTotal();
  }

  public lowDisagreePercentUpdate() {
    this.abstractSearchKeys.lowPriDisagreementSamplePercent = this.lowPriDisagreementSamplePercent;
    this.lowPriDisagreeAutoCount = Math.round(this.abstractsData.lowPriDisagreementCount * (this.lowPriDisagreementSamplePercent / 100));
    this.updateSampleTotal();
  }

  public fullAgreePercentUpdate() {
    this.abstractSearchKeys.fullAgreementSamplePercent = this.fullAgreementSamplePercent;
    this.fullAgreeAutoCount = Math.round(this.abstractsData.fullAgreementCount * (this.fullAgreementSamplePercent / 100));
    this.updateSampleTotal();
  }

  public updateSampleTotal() {
    this.totalAutoSampleCount = this.highPriDisagreeAutoCount + this.lowPriDisagreeAutoCount + this.fullAgreeAutoCount;

    if (!this.eligibleAbstractsWithMlDataCount || this.eligibleAbstractsWithMlDataCount == 0) {
      this.autoSelectPercent = 0;
    }
    else {
      // Using math.round to get to the nearest whole number by multiplying by 100 more than necessary (simulating 2 decimal places)
      this.autoSelectPercent = Math.round((this.totalAutoSampleCount / this.eligibleAbstractsWithMlDataCount) * 10000) / 100;
    }
    // Want to clear actual count data when a user changes percentages
    this.clearActualReconCountData();
  }

  public updateCurrentSampledValues() {
    if (!this.abstractsData.inQCListCount) {
      this.currentSampleNumber = 0;
    }
    else if (!this.abstractsData.inCoderQAndReconListCount) {
      this.currentSampleNumber = this.abstractsData.inQCListCount - 0;
    }
    else if (this.abstractsData.inQCListCount < this.abstractsData.inCoderQAndReconListCount) {
      this.currentSampleNumber = 0;
    }
    else {
      this.currentSampleNumber = this.abstractsData.inQCListCount - this.abstractsData.inCoderQAndReconListCount;
    }

    if (!this.abstractsData.reconEligibleCount || this.abstractsData.reconEligibleCount == 0) {
      this.currentSampleRatio = 0;
    }
    else if (!this.abstractsData.inCoderQListCount) {
      this.currentSampleRatio = Math.round((this.currentSampleNumber / this.abstractsData.reconEligibleCount) * 10000) / 100;
    }
    else if (this.abstractsData.reconEligibleCount - this.abstractsData.inCoderQListCount == 0) {
      this.currentSampleRatio = 0;
    }
    else {
      this.currentSampleRatio = Math.round((this.currentSampleNumber / (this.abstractsData.reconEligibleCount - this.abstractsData.inCoderQListCount)) * 10000) / 100;
    }
  }

  public clearActualReconCountData() {
    if (!this.isAutoSampling) {
      this.autoSampleHighPriDisagreeResultCount = 0;
      this.autoSampleLowPriDisagreeResultCount = 0;
      this.autoSampleFullAgreeResultCount = 0;
      this.actualAbstractsInReconWithMlDataCount = 0;
    }
  }

  public openSnackBar(message: string, action: string, secondsDuration?: number) {

    // -- 9/30/25 Glenn requested to remove snackbar timeout. Leaving this commented out in case we bring it back.

    // if (secondsDuration) {
    //   this.snackBar.open(message, action, {
    //     panelClass: ['snack-warning'],
    //     verticalPosition: 'top',
    //     horizontalPosition: 'center',
    //     // duration: secondsDuration * 1000
    //   });
    // }
    // else {
    
      // }
      this.snackBar.open(message, action, {
        panelClass: ['snack-warning'],
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
  }
}
